import { Breakpoints } from '@/styles/breakpoints'
import { useWidthBreakpoint } from './useWidthBreakpoint'

export const useIsMobile = () => useWidthBreakpoint(Breakpoints.mobile)
